import { Country } from '@types';

export const countryOptions = [
    { id: Country.GB, name: 'GB' },
    { id: Country.US, name: 'US' },
];
